import { AccountLogo } from '@frontend/components/common';
import { useAccountRepository, useBrandingRepository } from '@frontend/repository';

export interface MobileHeaderProps {
    className?: string;
}

function MobileHeader({ className }: MobileHeaderProps) {
    const { currentAccount } = useAccountRepository();
    const { logo_navbar_expanded } = useBrandingRepository();

    return (
        <header
            className={`bg-background-surface border-border-default sticky top-0 z-50 flex h-20 w-full items-center justify-between border-b px-6 md:hidden ${className ?? ''}`}>
            <a
                href='/'
                className='flex items-center'>
                <AccountLogo
                    accountId={currentAccount}
                    className='h-8 w-auto object-contain'
                    fallbackSrc={logo_navbar_expanded}
                />
            </a>
        </header>
    );
}

export default MobileHeader;
